import { FC, PropsWithChildren, useRef } from 'react';
import { useElementOnScreen } from '../../hooks/useElementOnScreen';

type AnimateInProps = PropsWithChildren<{
	msSpeed?: number;
	msDelay?: number;
	direction?: 'up' | 'down' | 'left' | 'right';
	noOpacity?: boolean;
}>;

export const AnimateIn: FC<AnimateInProps> = ({
	children,
	msSpeed = 500,
	msDelay = 0,
	direction = 'up',
	noOpacity = false,
}) => {
	const ref = useRef<HTMLDivElement>(null);
	const onScreen = useElementOnScreen(ref as React.RefObject<HTMLDivElement>);
	return (
		<div
			ref={ref}
			style={{
				opacity: onScreen || noOpacity ? 1 : 0,
				translate: onScreen
					? 'none'
					: direction === 'up'
					? '0 2rem'
					: direction === 'down'
					? '0 -2rem'
					: direction === 'left'
					? '2rem 0'
					: direction === 'right'
					? '-2rem 0'
					: 'none',
				transitionDuration: `${msSpeed}ms`,
				transitionDelay: `${msDelay}ms`,
			}}
		>
			{children}
		</div>
	);
};
